import React, { useState } from "react";
import Explainer from "../ExplainerModal";
import benchmarkingProcess from "../FlowCharts/Benchmarking-process.png"; // Importing the flowchart

const BenchmarkingExplainerModal = () => {
  const [isZoomed, setIsZoomed] = useState(false);

  return (
    <Explainer
      title="Policy Benchmarking Explainer"
      content={
        <>
          <h3 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "10px", color: "#137A08" }}>
            📊 Policy Benchmarking Overview
          </h3>
          <p>
            Policy Benchmarking evaluates the adequacy of policies by measuring their coverage, implementation, and effectiveness.
            The final score is a weighted combination of these three factors, providing insights into policy performance across various
            agri-food systems and countries.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            📈 Visualization
          </h3>
          <p>Benchmarking consists of two main sections: <strong>Systems</strong> and <strong>Country</strong>.</p>

          <ul>
            <li>🌾 <strong>Systems:</strong> Displays benchmarking scores for all agri-food systems (or the selected system) across AGRA-focus countries. Each score appears alongside regional averages.</li>
            <li>🌍 <strong>Country:</strong> Provides agri-food system scores per country, alongside regional and AGRA-focus country averages for comparison.</li>
            <li>📊 <strong>Radial Plots:</strong> Under each milestone, we visualize specific dimensions of system performance using radial plots.</li>
          </ul>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            📝 Data Entry Process
          </h3>
          <p>The following steps outline how users interact with the Benchmarking Data section:</p>
          <ol>
            <li>➡️ Navigate to the <strong>Data</strong> tab.</li>
            <li>➡️ Click on the assigned <strong>benchmarking milestone</strong>.</li>
            <li>🚫 If you are not a user or supervisor, you will see <em>"You don't have enough permissions."</em> You can only view responses.</li>
            <li>✅ <strong>Owner Responsibilities:</strong>
              <ul style={{ paddingLeft: "20px", marginTop: "5px" }}>
                <li>🖊️ Respond to milestone questions.</li>
                <li>📎 Attach supporting evidence.</li>
                <li>📤 Submit responses for <strong>Supervisor Approval</strong>.</li>
                <li>♻️ Update responses until they are approved.</li>
              </ul>
            </li>
            <li>🔎 <strong>Supervisor Responsibilities:</strong>
              <ul style={{ paddingLeft: "20px", marginTop: "5px" }}>
                <li>📝 Review and approve responses and evidence.</li>
                <li>🌍 Make responses public after approval.</li>
                <li>📢 Update responses as new information becomes available.</li>
              </ul>
            </li>
          </ol>

          <p><strong>Note:</strong> If you are both the <strong>Owner</strong> and <strong>Supervisor</strong>, submitting responses automatically makes them public.</p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            🧮 Benchmarking Score Calculation
          </h3>
          <p>
            Benchmarking scores are computed using the following formula:
          </p>
          <p style={{ backgroundColor: "#f4f4f4", padding: "10px", borderRadius: "5px", fontFamily: "monospace" }}>
            Benchmarking Score (%) = (Sum of Response Scores ÷ (Number of Questions per Milestone × 4)) × 100
          </p>
          <p>
            Here, <strong>4</strong> represents the highest possible score per question.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            🔄 Benchmarking Process Flowchart
          </h3>
          <div style={{ position: "relative", display: "inline-block" }}>
            <img
              src={benchmarkingProcess}
              alt="Benchmarking Process Flowchart"
              style={{ width: "100%", borderRadius: "8px", marginTop: "10px", cursor: "pointer" }}
              onClick={() => setIsZoomed(true)}
            />
            <button
              onClick={() => setIsZoomed(true)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "rgba(0, 0, 0, 0.7)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "20px",
                cursor: "pointer"
              }}
            >
              🔍 <span style={{ fontSize: "10px", color: "black" }}>Zoom</span>
            </button>
          </div>

          {isZoomed && (
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: "1000"
              }}
              onClick={() => setIsZoomed(false)}
            >
              <img
                src={benchmarkingProcess}
                alt="Zoomed Benchmarking Process Flowchart"
                style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "8px" }}
              />
            </div>
          )}
        </>
      }
    />
  );
};

export default BenchmarkingExplainerModal;
